/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { IntlProvider } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */


/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as CreateTeamSvg } from '../../../resources/images/people-dark-large.svg';

/* Styles */
import styles from "./styles";

const DeleteTeamModal = ({showDeleteTeamModal, setShowDeleteTeamModal, teamId, teamName}) => {
  const theme = useTheme();
  const classes = styles({ theme });


  const handleSaveModal = () => {
    setShowDeleteTeamModal(false)
  }

  return (
      <UCModal
        className={classes.editTeamModal}
        showModal={ showDeleteTeamModal }
        setShowModal={ setShowDeleteTeamModal }
        modalIcon={ <CreateTeamSvg /> }
        modalTitle={ <FormattedMessage id="deleteTeam.title" values={{ teamName: teamName }}/> }
        modalDescription={ <FormattedMessage id="deleteTeam.description"/> }
        modalContent={ <Content setShowModal={setShowDeleteTeamModal} handleSaveModal={handleSaveModal} teamId={teamId}/> }
        dataTestId="deleteTeamModal"
      />
  )
}

export default DeleteTeamModal;
